import { Modal } from "antd";

export enum ModalType {
  COURSE_DELETE = "course_delete",
  SECTION_DELETE = "section_delete",
  LESSON_DELETE = "lesson_delete",
  TASK_DELETE = "task_delete",
  USER_DELETE = "user_delete",
  COUPON_DELETE = "coupon_delete",
  WORD_DELETE = "word_delete",
  REWARD_DELETE = "reward_delete",
  DOMAIN_TAG_DELETE = "domain_tag_delete",
  NOTIFICATION_DELETE = "notification_delete",
  WORD_PACK_DELETE = "word_pack_delete",
  LOGOUT = "logout",
}

interface ModalProps {
  isModalOpen: boolean;
  handleOk: () => void;
  onCancel: () => void;
  type: ModalType;
  name?: string;
}

const getModalText = (type: ModalType, name = "") => {
  switch (type) {
    case ModalType.COURSE_DELETE:
      return {
        title: `Курс ${name}?`,
        test: `Вы уверены, что хотите удалить ${name}?`,
        okText: "Удалить",
      };
      break;

    case ModalType.SECTION_DELETE:
      return {
        title: `Секция ${name}?`,
        test: `Вы уверены, что хотите удалить ${name}?`,
        okText: "Удалить",
      };
      break;

    case ModalType.LESSON_DELETE:
      return {
        title: `Урок ${name}?`,
        test: `Вы уверены, что хотите удалить ${name}?`,
        okText: "Удалить",
      };
      break;

    case ModalType.TASK_DELETE:
      return {
        title: `Задание ${name}?`,
        test: `Вы уверены, что хотите удалить ${name}?`,
        okText: "Удалить",
      };
      break;
    case ModalType.USER_DELETE:
      return {
        title: `Пользователь ${name}?`,
        test: `Вы уверены, что хотите удалить ${name}?`,
        okText: "Удалить",
      };
      break;

    case ModalType.COUPON_DELETE:
      return {
        title: `Купок ${name}?`,
        test: `Вы уверены, что хотите удалить ${name}?`,
        okText: "Удалить",
      };
      break;

    case ModalType.WORD_DELETE:
      return {
        title: `Слово ${name}?`,
        test: `Вы уверены, что хотите удалить ${name}?`,
        okText: "Удалить",
      };
      break;

    case ModalType.REWARD_DELETE:
      return {
        title: `Фраза ${name}?`,
        test: `Вы уверены, что хотите удалить эту фразу?`,
        okText: "Удалить",
      };
      break;

    case ModalType.DOMAIN_TAG_DELETE:
      return {
        title: `Раздел ${name}?`,
        test: `Вы уверены, что хотите удалить этот раздел?`,
        okText: "Удалить",
      };
      break;

    case ModalType.NOTIFICATION_DELETE:
      return {
        title: `Уведомление ${name}?`,
        test: `Вы уверены, что хотите удалить это уведомление?`,
        okText: "Удалить",
      };
      break;

    case ModalType.WORD_PACK_DELETE:
      return {
        title: `Папка ${name}?`,
        test: `Вы уверены, что хотите удалить папку «${name}»? Это действие необратимо.`,
        okText: "Удалить",
      };
      break;

    case ModalType.LOGOUT:
      return {
        title: "Выход из системы",
        test: "Вы действительно хотите выйти?",
        okText: "Выйти",
      };
      break;

    default:
      return {};
  }
};

export const CustomModal = (props: ModalProps) => {
  const { isModalOpen, handleOk, onCancel, type, name } = props;

  const textModal = getModalText(type, name);

  return (
    <Modal
      title={textModal.title}
      open={isModalOpen}
      onOk={handleOk}
      onCancel={onCancel}
      okText={textModal.okText}
    >
      <p>{textModal.test}</p>
    </Modal>
  );
};
